import { lazy, Suspense, useMemo } from 'react';
import { useTranslationReady } from '@/hooks/useTranslationReady';
import { Loader2 } from 'lucide-react';

interface LazyTemplateProps {
  importFn: () => Promise<{ default: React.ComponentType<any> }>;
  namespace: string;
  [key: string]: any;  // Allow additional props like 'profile'
}

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}

export function LazyTemplate({ importFn, namespace, ...props }: LazyTemplateProps) {
  const translationsReady = useTranslationReady(namespace);
  const LazyComponent = useMemo(() => lazy(importFn), [importFn]);

  if (!translationsReady) {
    return <LoadingFallback />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      <LazyComponent {...props} />
    </Suspense>
  );
}
